import {FC} from "react";
import {HiveColLink} from "features/devices/ui/components/styles.ts";

export const HiveCol: FC<{name: string, id: string}> = ({name, id}) => {
    return (
        <HiveColLink to={`/hive/${id}`}>
            {name}
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24.000000" height="24.000000" fill="none">
                <rect id="24 / Navigation / Chevron right" width="24.000000" height="24.000000" x="0.000000" y="0.000000" />
                <path id="Union" d="M0.221149 5.46945L5.72115 0L6.77885 1.06361L1.81363 6.00126L6.77885 10.9389L5.72115 12.0025L0.221149 6.53306C0.0795921 6.39229 1.22924e-17 6.2009 0 6.00126C-1.22924e-17 5.80162 0.0795921 5.61023 0.221149 5.46945Z" fill="rgb(16,24,40)" fill-rule="evenodd" transform="matrix(-1,0,0,1,15.7789,5.99982)" />
            </svg>
        </HiveColLink>
    );
};

export default HiveCol;